import { useEffect, useRef } from "react";
import { Row, Form, Col, Spinner } from "react-bootstrap";
import { agreedWithTcState } from "atoms";
import { useRecoilState, useSetRecoilState } from "recoil";
import { CartModel } from "atoms/models";
import { useWrapRequest } from "utils";
import { getServiceAgreement } from "services/get-serviceAgreement";
import "components/Confirm/confirm.scss";
import { termsAndConditionsAgreementAcceptedState } from "atoms";

const MonthlySubscriptionTermsCheckbox: React.FC<{
  cart: CartModel;
  tcServiceAgreement: Boolean;
  setTermsAndConditionsModal: Function;
}> = ({ cart, tcServiceAgreement, setTermsAndConditionsModal }) => {
  const [agreedWithTc, setAgreedWithTc] = useRecoilState(agreedWithTcState);
  const setServiceAgreement = useSetRecoilState(termsAndConditionsAgreementAcceptedState);
  const wrapRequest = useWrapRequest();
  const htmlRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const fetchInitialData = async () => {
      wrapRequest(async () => {
        const serviceAgreementResponse = await getServiceAgreement();
        setServiceAgreement(serviceAgreementResponse);
      });
    };
    fetchInitialData();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setTimeout(() => {
      // Remove inline styles after HTML is rendered
      if (htmlRef.current) {
        // Remove inline styles from all elements inside htmlRef
        const elementsWithStyles = htmlRef.current.querySelectorAll("*");
        elementsWithStyles.forEach((element) => {
          element.removeAttribute("style");
          element.removeAttribute("width");
        });

        const tableElement = htmlRef.current.querySelector('table[cellpadding="7"]') as HTMLTableCellElement;

        if (tableElement) {
          tableElement.style.width = "100%";
        }
      }
    }, 2000);
  }, []);

  return (
    <>
      <Row className="mt-2">
        <Col className={`d-flex ${cart?.isCurrentCustomer || cart?.promotionCode?.enabled ? "justify-content-end me-3" : "justify-content-center"}`}>
          {cart.isServiceAgreementRequired && tcServiceAgreement ? (
            <>
              <Form.Check id="tc" className="me-3 checkbox-vertical-align">
                <Form.Check.Input
                  checked={agreedWithTc}
                  disabled={agreedWithTc}
                  className="align-text-bottom"
                  onChange={() => {
                    setAgreedWithTc(!agreedWithTc);
                    setTermsAndConditionsModal(false);
                  }}
                />
              </Form.Check>
              <div>
                <label htmlFor="tc" className="align-middle mb-3">
                  I agree with the Terms and Conditions.
                </label>
              </div>
            </>
          ) : (
            <div className="text-center">
              <p>Loading service agreement</p>
              <Spinner animation="border" />
            </div>
          )}
        </Col>
      </Row>
    </>
  );
};

export default MonthlySubscriptionTermsCheckbox;
